import {Grid, Typography } from '@mui/material';
import {
    Outlet
  } from 'react-router-dom';

const TemplateManagement = () => {
    return (
        <Grid >
            <Typography variant="h5" component="h2">
                Template Management
            </Typography>
            <Outlet />
        </Grid> 
    )
}

export default TemplateManagement;